import React from 'react';
import '../../pages/medwiki/css/medwikiDetails.scss';
import { Skeleton } from '../Skeleton';
import CommentLoader from './commentLoader';

function MedwikiDetailsLoader() {
  return (
    <>
      <section className="detailsPageLeft pe-0 pe-lg-5">
        <div className="w-100 detailsPageLeftVideo" id="clinical_video_details_feature_vedio">
          <Skeleton variant="rectangle" width="100%" height={450} />
        </div>
        <div className="w-100 dtlsPageLeftBody mt-3">
          <div className="w-100 dtlsTrigrBar d-flex justify-content-between align-items-center border-bottom border-light pb-3">
            <div className="dtlsTrigrBarLeft text-start">
              <ul className="text-black ps-0">
                <li className={`d-inline-block me-2 me-md-3 pe-2 pe-md-3 py-2 cursorPointer`}>
                  <Skeleton variant="circular" width={30} height={30} />
                </li>
                <li className={`d-inline-block me-2 me-md-3 pe-2 pe-md-3 py-2 cursorPointer`}>
                  <Skeleton variant="circular" width={30} height={30} />
                </li>
                <li className="d-inline-block me-2 me-md-3 pe-2 pe-md-3 py-2 cursorPointer">
                  <Skeleton variant="circular" width={30} height={30} />
                </li>
                <li className="d-inline-block py-2 cursorPointer">
                  <Skeleton variant="circular" width={30} height={30} />
                </li>
              </ul>
            </div>
            <div className="dtlsTrigrBarRight">
            </div>
          </div>

          <div className="w-100 text-start dtlsContet mt-3 mt-lg-4">
            <div className="w-100 dtlsTtlArea position-relative ps-0">
              {' '}
              <span className="text-black fs-4 dtlsSpeclty d-inline-block mb-2">
                <Skeleton variant="text" width={80} height={20} />
              </span>
              <h1 className="text-black fs-2">
                <Skeleton variant="text" width={100} height={30} />
              </h1>
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="80%" height={20} />
            </div>

            <div className="clearfix"></div>

            <div className="w-100 dtlsDescription fs-16 mt-4">
              <Skeleton variant="text" width={100} height={30} />
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="80%" height={20} />
            </div>
          </div>
          <div className="w-100 text-start dtlsComment mt-5" id="detailsComments">
          </div>
          <div className="w-100 text-start fs-5 disclaimer mt-5 rounded bg-white">
            <h6 className="text-black fs-5">Disclaimer</h6>
            <p>
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="80%" height={20} />
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default MedwikiDetailsLoader;
